import React from 'react';
import { FaBars } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box, IconButton } from '@tq/ui-components';
import { useDisclosure } from '@tq/ui-components/dist/hooks';

import { MobileMenuDrawer } from './MobileMenuDrawer';

export const MobileMenu: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation('mobile_menu');

  return (
    <Box px={2}>
      <IconButton
        onClick={onOpen}
        icon={<FaBars />}
        w={11}
        h={10}
        bgColor='transparent'
        color={COLOURS.blue[600]}
        borderRadius='0.25rem'
        _hover={{ backgroundColor: 'none' }}
        _active={{ backgroundColor: 'none' }}
        _focus={{
          outline: 'none',
          borderColor: COLOURS.blue[200],
        }}
        aria-label={t('mobile_hamburger_menu_button', 'Mobile Hamburger Menu Button')}
        sx={{
          '& div:first-of-type': {
            zIndex: '11',
          },
          '& svg': { w: 7, h: 7 },

          '&:focus': {
            boxShadow: '0 0 3px 2px #4CAAF0',
          },
        }}
      />
      <MobileMenuDrawer isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};
